/**
 * @param {Vue} vm - component instance with $t / $te (vue-i18n)
 * @param {string} code - currency code e.g. CNY
 */
export function currencyUnitLabel(vm, code) {
  if (!code) return "";
  const c = String(code).toUpperCase();
  if (vm.$te("login.currency." + c)) return vm.$t("login.currency." + c);
  if (vm.$te("global.currency." + c)) return vm.$t("global.currency." + c);
  return c;
}
